import { Injectable, Inject } from '@angular/core'; 
import { Router } from '@angular/router';
import { Users, slaNote, userrights} from './../models/users'
//import { ApiService } from './api.service';
//import { LangService } from './lang.service';
import { AdminApiService } from './../services/admin.service';
import { AngularGridInstance } from 'angular-slickgrid';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { RSAHelper } from './../models/RSAHelper';
import { tenant } from '../models/admin';
import { Console } from 'console';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  angularGrid: AngularGridInstance;
  public headers: Headers;
  apiURL: string = "";
  PingEnabled = false;
  dataEntryCount: any;
  approvalCount: any;
  completedKPICount: any;
  public user: any = {};
  sidebarVisibilityChange: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient, private _router: Router, public restApi: AdminApiService,public RASHelper: RSAHelper, ) {
    //this.headers = new Headers({ 'Content-Type': 'application/json' });
    //let options = new RequestOptions({ headers: this.headers });
    //this.apiURL = baseUrl;
    this.PingEnabled = environment.PingEnabled;
    
  }
  refreshLeftNavCount(dataEntryCountValue, approvalCountValue, completedKPICountValue) {
    let value = [];
    value[0] = dataEntryCountValue;
    value[1] = approvalCountValue;
    value[2] = completedKPICountValue;
    this.sidebarVisibilityChange.next(value);
  }

  getCurrentLanguage() {

   // var lng = this._langService.getLang();
   // if (lng) { return lng.ISOCode; }
    //else { return 'en'; }
    return 'en'; 
  }
 
  logout() {
    try {

      let objusers = new Users;
      let users = this.getUserInfo();
      objusers.userUno = users.id;
      //logging Logout details
      this.restApi.SetLoginInfo_ByUserID(objusers).subscribe(
        data => {
          let inboxstVal = 'inbox_filter_musherat_storage';
          localStorage.removeItem(inboxstVal);

          localStorage.removeItem('musherataccesstoken');
          localStorage.removeItem('userinfo');
          localStorage.removeItem('accessinfo');
          localStorage.removeItem('userrights');
          localStorage.removeItem('externalUseraccess');       
          localStorage.removeItem('authorization.service.issuer_uri');
          localStorage.removeItem('authorization.service.parsed_openid_configuration');
          localStorage.removeItem('authorization.service.token_response');
          localStorage.removeItem('authorization.service.user_info');
          localStorage.removeItem('pingID_code');
          localStorage.removeItem('ping_un');

          this._router.navigate(['/clear-page']);
          
        },
        error => {
         
         let inboxstVal = 'inbox_filter_musherat_storage';
          localStorage.removeItem(inboxstVal);
          localStorage.removeItem('musherataccesstoken');
          localStorage.removeItem('userinfo');
          localStorage.removeItem('accessinfo');
          localStorage.removeItem('userrights');
          localStorage.removeItem('externalUseraccess');
          localStorage.removeItem('authorization.service.issuer_uri');
          localStorage.removeItem('authorization.service.parsed_openid_configuration');
          localStorage.removeItem('authorization.service.token_response');
          localStorage.removeItem('authorization.service.user_info');
          localStorage.removeItem('pingID_code');
          localStorage.removeItem('ping_un');
          this._router.navigate(['/clear-page']);
        },
        () => {
          //this._router.navigate(['/']);
        });  

    } catch (e) {

      let inboxstVal = 'inbox_filter_musherat_storage';
          localStorage.removeItem(inboxstVal);
          localStorage.removeItem('musherataccesstoken');
          localStorage.removeItem('userinfo');
          localStorage.removeItem('accessinfo');
          localStorage.removeItem('userrights');
          localStorage.removeItem('externalUseraccess');         
          localStorage.removeItem('authorization.service.issuer_uri');
          localStorage.removeItem('authorization.service.parsed_openid_configuration');
          localStorage.removeItem('authorization.service.token_response');
          localStorage.removeItem('authorization.service.user_info');
          localStorage.removeItem('pingID_code');
          localStorage.removeItem('ping_un');
          this._router.navigate(['/clear-page']);
    }

  }

  getUserInfo() {
    var user;
    var struser = localStorage.getItem('userinfo');
    if (struser) {
      user = JSON.parse(struser);
    }
    return user;
  }
  getUserRights(pagename:string) {
    let userRightsData: any = [];
    var struserRights = localStorage.getItem('userrights');
    if (struserRights) {
      var userRights: any = JSON.parse(struserRights);
      userRightsData = userRights.filter(item => item.pageName == pagename);
    }
    return userRightsData;
  }
  getSwitchTenantInfo() {
    var Tenant;
    var struser = localStorage.getItem('switchTenant');
    if (struser) {
      Tenant = JSON.parse(struser);
    }
    return Tenant;
  }
  getRights_Toolbar(permision_add: boolean, permision_edit: boolean, permision_delete:boolean) {
    if (permision_add && permision_edit && permision_delete) {
      return ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && permision_edit && permision_delete) {
      return ['Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && !permision_edit && permision_delete) {
      return ['Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (permision_add && permision_edit && !permision_delete) {
      return ['Add','Edit','Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (permision_add && !permision_edit && permision_delete) {
      return ['Add','Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (permision_add && !permision_edit && !permision_delete) {
      return ['Add','Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && permision_edit && !permision_delete) {
      return ['Update','Edit', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && !permision_edit && !permision_delete) {
      return ['Search','ExcelExport'];
    }    
    return ['Search', 'ExcelExport'];
  }

  getRights_ToolbarWithoutExcel(permision_add: boolean, permision_edit: boolean, permision_delete: boolean) {
    if (permision_add && permision_edit && permision_delete) {
      return ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search'];
    }
    if (!permision_add && permision_edit && permision_delete) {
      return ['Edit', 'Delete', 'Update', 'Cancel', 'Search'];
    }
    if (!permision_add && !permision_edit && permision_delete) {
      return ['Delete', 'Update', 'Cancel', 'Search'];
    }
    if (permision_add && permision_edit && !permision_delete) {
      return ['Add', 'Edit', 'Update', 'Cancel', 'Search'];
    }
    if (permision_add && !permision_edit && permision_delete) {
      return ['Add', 'Delete', 'Update', 'Cancel', 'Search'];
    }
    if (permision_add && !permision_edit && !permision_delete) {
      return ['Add', 'Update', 'Cancel', 'Search'];
    }
    if (!permision_add && permision_edit && !permision_delete) {
      return ['Update', 'Edit', 'Cancel', 'Search'];
    }
    if (!permision_add && !permision_edit && !permision_delete) {
      return ['Search'];
    }
    return ['Search'];
  }

  getRights_Toolbar_kpi(permision_add: boolean, permision_edit: boolean, permision_delete: boolean) {
    if (permision_add && permision_edit && permision_delete) {
      return ['Edit', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && permision_edit && permision_delete) {
      return ['Edit', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    //if (!permision_add && !permision_edit && permision_delete) {
    //  return ['Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    //}
    if (permision_add && permision_edit && !permision_delete) {
      return ['Edit', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (permision_add && !permision_edit && permision_delete) {
      return ['Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (permision_add && !permision_edit && !permision_delete) {
      return ['Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && permision_edit && !permision_delete) {
      return ['Update', 'Edit', 'Cancel', 'Search', 'ExcelExport'];
    }
    if (!permision_add && !permision_edit && !permision_delete) {
      return ['Search', 'ExcelExport'];
    }
    return ['Search', 'ExcelExport'];
  }
  getRights_Toolbar_kpi_withoutexcel(permision_add: boolean, permision_edit: boolean, permision_delete: boolean) {
    if (permision_add && permision_edit && permision_delete) {
      return ['Edit', 'Update', 'Cancel', 'Search'];
    }
    if (!permision_add && permision_edit && permision_delete) {
      return ['Edit', 'Update', 'Cancel', 'Search'];
    }
    //if (!permision_add && !permision_edit && permision_delete) {
    //  return ['Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    //}
    if (permision_add && permision_edit && !permision_delete) {
      return ['Edit', 'Update', 'Cancel', 'Search'];
    }
    if (permision_add && !permision_edit && permision_delete) {
      return ['Update', 'Cancel', 'Search'];
    }
    if (permision_add && !permision_edit && !permision_delete) {
      return ['Update', 'Cancel', 'Search'];
    }
    if (!permision_add && permision_edit && !permision_delete) {
      return ['Update', 'Edit', 'Cancel', 'Search'];
    }
    if (!permision_add && !permision_edit && !permision_delete) {
      return ['Search'];
    }
    return ['Search'];
  }
  UpdatetUserTermsInfo() {


    var struser = localStorage.getItem('userinfo');
    if (struser) {
      struser = struser.replace('"termsandconditions":"0"', '"termsandconditions":"1"');
      localStorage.removeItem('userinfo');
      localStorage.setItem('userinfo', struser);
    }
  }

  allowedFileExtension(fileName: string) {
    /* var strTitle = (fileName.indexOf('.') > 0) ? fileName.split('.')[1].toLowerCase() : 'unknown';*/
    console.log(fileName.match(/\./g).length, fileName, 'fileName . length');
    if (fileName.match(/\./g).length > 1) {
      return false;
    }
    var fileNameSplitArray = fileName.split('.');
    var strTitle = (fileName.lastIndexOf('.') > 0) ? fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase() : 'unknown';
    let returnValue = false;

    switch (strTitle) {
      case 'txt':
        returnValue = true;
        break;
      case 'doc':
        returnValue = true;
        break;
      case 'docx':
        returnValue = true;
        break;
      case 'xls':
        returnValue = true;
        break;
      case 'xlsx':
        returnValue = true;
        break;
      case 'pdf':
        returnValue = true;
        break;

      case 'jpeg':
      case 'jpg':
      case 'png':
        returnValue = true;
        break;
      case 'ppt':
      case 'pptx':
        returnValue = true;
        break;

      default:
        returnValue = false;
        break;
    }

    return returnValue;
  }

  checkFileValuranabity(fileName: string, filesize:any) {
    let allowFile = false;
    //filename contains .exe
    if (!(fileName.indexOf('.exe') !== -1) || !(fileName.indexOf('exe') !== -1)) {
      //allow Maximum 30 MB File
      if (filesize < 31457280) {
        //allowed File Extension
        if (this.allowedFileExtension(fileName)) {
          allowFile = true;
        }
        else {
          allowFile = false;
        }
      }
      else {
        allowFile = false;
      }

    }
    else {
      allowFile = false;
    }

    return allowFile;
  }

  checkFileSize(filesize: any) {
    let allowFileSize = false;
    //allow Maximum 30 MB File
    if (filesize < 31457280) {
      allowFileSize = true;
    }
    return allowFileSize;
  }

  checkImageValuranabity(fileName: string, filesize: any) {
    let allowFile = false;
    //filename contains .exe
    if (!(fileName.indexOf('.exe') !== -1) || !(fileName.indexOf('exe') !== -1)) {
        //allowed File Extension
        if (this.allowedImageExtension(fileName)) {
          allowFile = true;
        }
        else {
          allowFile = false;
        }
    }
    else {
      allowFile = false;
    }

    return allowFile;
  }

  allowedImageExtension(fileName: string) {
    var fileNameSplitArray = fileName.split('.');
    var strTitle = (fileName.lastIndexOf('.') > 0) ? fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase() : 'unknown';
    let returnValue = false;

    switch (strTitle) {
      case 'jpeg':
      case 'jpg':
      case 'png':
        returnValue = true;
        break;
      default:
        returnValue = false;
        break;
    }

    return returnValue;
  }

  getSLAFilterInfo() {
    var filter;
    var strfilter = localStorage.getItem('SlaPeformanceFilter');
    if (strfilter) {
      filter = JSON.parse(strfilter);
    }
    return filter;
  }

  getSLAKPIFilterInfo() {
    var filter;
    var strfilter = localStorage.getItem('SlaKpiPeformanceFilter');
    if (strfilter) {
      filter = JSON.parse(strfilter);
    }
    return filter;
  }
  getFilterInfo() {
    var filter;
    var strfilter = localStorage.getItem('strFilter');
    if (strfilter) {
      filter = JSON.parse(strfilter);
    }
    return filter;
  }

  getPingUserInfo() {
    var user;
     var struser = sessionStorage.getItem('userinfo');
      //console.log('reached step 3');
      if (struser) {
        //console.log('reached step 4');
        user = JSON.parse(struser);
      }
    
    //added to check if login not exists
    if (user === null) {
      this._router.navigate(['/login']);
    }
    //console.log('reached step 2.2');
    return user;
  }

  CheckLogin() {
  if (!environment.isExternalUser) {

    // To Check ExternalUser
    const strExtuser = localStorage.getItem('externalUseraccess');
    let isExternalUser: any = '0';

    if (strExtuser) {
      const objExUser = JSON.parse(strExtuser);
      isExternalUser = objExUser.isExternalUser;
    }

    this.restApi
      .verifyPingAccessToken(localStorage.getItem('musherataccesstoken'))
      .subscribe({
        next: (data: any) => {
          const result = JSON.parse(data.data);
          const isActive = result.active;

          if (isActive) {
            let email: string | undefined;

            if (result.email) { 
              email = result.email.trim(); 
            } 
            if (email && !email.includes('@')) 
            { 
              email += '@dewa.gov.ae'; 
            }
            
            localStorage.setItem('ping_un', this.RASHelper.encryptWithPublicKey(email));
          } else {
            this.logout();
          }
        },
        error: (err) => {
          console.log('ERROR: ', err);
        }
      });
  }
}

  getTenantInfo(tenantUno: number, item: any, page: any) {
    this.user = this.getUserInfo();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = tenantUno;
    inpValue.condition = 2;
    inpValue.userUno = this.user.id;//this.RASHelper.encryptWithPublicKey('1');
    this.restApi.getTenants(inpValue)
      .subscribe(data => {
        
        var isDigitalUser = (tenantUno == this.user.tenantDigitalUno) ? true : false;
        let tenantData: any = data;
        if (tenantData != null && tenantData.length > 0) {
          this.user.slaname = tenantData[0].slaName;
          this.user.siteHeading = tenantData[0].siteHeading;
          this.user.isDynamicEntry = (tenantData[0].isDynamicEntry == 1) ? 'true' : 'false';

          this.user.currentYear = tenantData[0].currentYear;
          this.user.currentHalf = tenantData[0].currentHalf;
          this.user.currentMonth = tenantData[0].currentMonth;
          this.user.currentQuarter = tenantData[0].currentQuarter;
          this.user.wellperformKPIRange = tenantData[0].wellPerformKPIRange;
        }
        try {

          var userid = this.user.id;

          var roleType = item.userTypeName;
          var userName = this.user.username;

          let objUser = new slaNote;
          objUser.userUno = userid;
          objUser.type = roleType;
          objUser.userName = userName;
          //debugger;
          this.restApi.GetGenToken(objUser).subscribe(
            (res: any) => {
              let rtnValue = res.value;
              //debugger;
              localStorage.removeItem('accessinfo');
              localStorage.setItem('accessinfo', '{"token":"' + rtnValue + '"}');

              var struser = '{"id":"' + this.user.id + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + item.userTypeName + '","desingation":"' + this.user.desingation + '","division":"' + item.divisionName + '","divisionUno":"' + item.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + item.userTypeUno + '","userGroupUno":"' + item.userRoleUno + '","userGroup":"' + item.userRoleName + '"}';
              localStorage.removeItem('userinfo');
              localStorage.setItem('userinfo', struser);

              // remove inbox filter:
              let inboxstVal = 'inbox_filter_musherat_storage';
              localStorage.removeItem(inboxstVal);

              this.loadUserRights(this.user.id, item.userTypeUno, tenantUno);
              this.user = this.getUserInfo();
             // var temp = this;
              //setTimeout(() => {

                if (this.user.userroleType == 5 || this.user.userroleType == 6 || this.user.userroleType == 7 || this.user.userroleType == 8) {
                  //this.router.navigate(['/benchmark-home']);

                  window.location.href = "#/benchmark-home";
                  window.location.reload();
                }
                else if (this.user.tenantUno == '6') {

                  let decryptUID = this.RASHelper.decryptWithPrivateKey(this.user.id.toString());

                  var struser = '{"id":"' + decryptUID + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + this.user.role + '","desingation":"' + this.user.desingation + '","division":"' + this.user.division + '","divisionUno":"' + this.user.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + this.user.userroleType + '","userGroupUno":"' + this.user.userGroupUno + '","userGroup":"' + this.user.userGroup + '"}';

                  localStorage.removeItem('userinfo');
                  localStorage.setItem('userinfo', struser);

                  window.location.href = "bsc/dashboard";
                }
                else {
                  //window.location.href = "#/dashboard";

                  this.onredirectPage(page);
                  window.location.reload();
                  //window.location.href = "#/userprofile";
                  //this.router.navigate(['/dashboard']);
                }

             // }, 700);

            },
            error => {


            },
            () => {

            });
        } catch (e) {


        }







      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });

    return false;
  }

  switchTenantConfiguration(tenantUno: number, isDigitalUser:any, item: any, page: any) {
    try {
      
      var userid = this.user.id

      var roleType = item.userTypeName;
      var userName = this.user.username;

      let objUser = new slaNote;
      objUser.userUno = userid;
      objUser.type = roleType;
      objUser.userName = userName;
      //debugger;
      this.restApi.GetGenToken(objUser).subscribe(
        (res: any) => {
          let rtnValue = res.value;
          //debugger;
          localStorage.removeItem('accessinfo');
          localStorage.setItem('accessinfo', '{"token":"' + rtnValue + '"}');

          var struser = '{"id":"' + this.user.id + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + item.userTypeName + '","desingation":"' + this.user.desingation + '","division":"' + item.divisionName + '","divisionUno":"' + item.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + item.userTypeUno + '","userGroupUno":"' + item.userRoleUno + '","userGroup":"' + item.userRoleName + '"}';
          localStorage.removeItem('userinfo');
          localStorage.setItem('userinfo', struser);

          // remove inbox filter:
          let inboxstVal = 'inbox_filter_musherat_storage';
          localStorage.removeloadUserRightsItem(inboxstVal);

          this.loadUserRights(this.user.id, item.userTypeUno,tenantUno);
          setTimeout(() => {

            if (this.user.userroleType == 5 || this.user.userroleType == 6 || this.user.userroleType == 7 || this.user.userroleType == 8) {
              //this.router.navigate(['/benchmark-home']);

              window.location.href = "#/benchmark-home";
              window.location.reload();
            }
            else if (this.user.tenantUno == 6) {
              window.location.href = "bsc/dashboard";
            }
            else {
              //window.location.href = "#/dashboard";
              this.onredirectPage(page);
              window.location.reload();
              //window.location.href = "#/userprofile";
              //this.router.navigate(['/dashboard']);
            }

          }, 700);

        },
        error => {


        },
        () => {

        });
    } catch (e) {


    }

  }
  loadUserRights(userUno, userGroupUno, tenantUno) {


    let inpValue = new userrights();
    inpValue.languageUno = 1033;
    inpValue.condition = 1;
    inpValue.tenantUno = tenantUno;
    inpValue.userUno = userUno;
    inpValue.pageUno = 0;
    inpValue.usergroupUno = userGroupUno;

    this.restApi.getUserRights(inpValue)
      .subscribe(data => {

        var struserrights = JSON.stringify(data);
        localStorage.removeItem('userrights');
        localStorage.setItem('userrights', struserrights);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  onredirectPage( page: any) {
    //debugger;
    if (page == 'inbox') {
      window.location.href = "#/inbox/dataentry";
    }
    else if (page == 'sladashboard') {
      window.location.href = "#/sladashboard/general";
    }
    else if (page == 'slaperformance') {
      window.location.href = "#/dashboard-slaperformance";
    }
    else if (page == 'digitaldashboard') {
      window.location.href = "#/dashboard-digital";
    }
    else if (page == 'moro') {
      window.location.href = "#/slakpiperformance?pagetype=Moro";
    }
    else if (page == 'digitalx') {
      window.location.href = "#/slakpiperformance?pagetype=DigitalX";
    }
    else if (page == 'infrax') {
      window.location.href = "#/slakpiperformance?pagetype=InfraX";
    }
    else {
      window.location.href = "#/dashboard";
    }

    return false;
  }


}
